/* istanbul ignore file */
export enum EventCatalogueSortField {
  title,
  lastUsed
}
